export enum PortingRequestStatus {
  UNSET_PORTING_REQUEST = 'UNSET_PORTING_REQUEST', // Do not use, needed because of proto3 limitations

  /* Platform statuses */
  PORTING_REQUESTED = 'PORTING_REQUESTED', // Porting requested on the platform
  PORTING_READY_FOR_SCHEDULING = 'PORTING_READY_FOR_SCHEDULING', // Porting need to be scheduled on the platform
  PORTING_SCHEDULED = 'PORTING_SCHEDULED', // Porting scheduled on the platform and ready for execution

  /* Internal statuses - Post platform execution */
  PORTING_PENDING = 'PORTING_PENDING', // Porting executed on the platfrom and pending for internal execution
  PORTING_PROCESSING = 'PORTING_PROCESSING', // Porting request processing internally
  PORTING_COMPLETED = 'PORTING_COMPLETED', // Porting request completed
  PORTING_PARTIALLY_COMPLETED = 'PORTING_PARTIALLY_COMPLETED', // Porting partially completed (corporate porting only)

  /* Failure and cancellation */
  PORTING_FAILED = 'PORTING_FAILED', // Platform or internal failure
  PORTING_CANCELLATION_PENDING = 'PORTING_CANCELLATION_PENDING', // Cancellation requested on the platform
  PORTING_CANCELLED = 'PORTING_CANCELLED', // Porting request cancelled
  PORTING_REJECTED = 'PORTING_REJECTED',
  PORTING_REJECTION_PENDING = 'PORTING_REJECTION_PENDING'

}
